<template>
  <div id="app">
    <access-suspension-overlay />
    <upgrade-modal
      :is-visible="isUpgradeModalVisible"
      @close="closeUpgradeModal"
    />
    <localization></localization>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Localization from "@/localization";
import apiClient, { setInitialRefresh } from "@/services/axios";
import Amiri from "raw-loader!./assets/fonts/Amiri.txt";
import pt_bold_heading from "raw-loader!./assets/fonts/pt_bold_heading.txt";
import noto from "raw-loader!./assets/fonts/NotoSansArabic-Bold.txt";
import amiri_bold from "raw-loader!./assets/fonts/Amiri-Bold.txt";
import NotoNaskhArabic_Bold from "raw-loader!./assets/fonts/NotoNaskhArabic-Bold-bold.txt";
import NotoNaskhArabic_Normal from "raw-loader!./assets/fonts/NotoNaskhArabic-Regular-normal.txt";
import Al_Jazeera_Arabic from "raw-loader!./assets/fonts/Al-Jazeera-Arabic.txt";

import upgradeModal from "@/components/packs/upgradeModal.vue";
import AccessSuspensionOverlay from "@/components/AccessSuspensionOverlay.vue";
import JsPDF from "jspdf";
export default {
  name: "app",
  components: {
    Localization,
    upgradeModal,
    AccessSuspensionOverlay,
  },
  computed: {
    ...mapState(["settings"]),
    ...mapState("settings", ["isUpgradeModalVisible"]),
    ...mapState("user", ["authorized"]),
    nextRoute() {
      return this.$route.query.redirect || "/";
    },
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions("settings", ["openUpgradeModal", "closeUpgradeModal"]),
  },
  created() {
    if (this.settings.base_url) {
      console.info(
        "setting up base URL :" + this.settings.base_url + "/api/web"
      );
      console.info("setting DB :" + this.settings.activeBuilding);
      apiClient.defaults.baseURL = this.settings.base_url + "/api/web";
      apiClient.defaults.headers.db = this.settings.activeBuilding;
    }
    //set Amiri font for unicode carrecters
    var callAddFont = function () {
      this.addFileToVFS("Amiri-normal.ttf", Amiri);
      this.addFont("Amiri-normal.ttf", "Amiri", "normal");
      this.addFileToVFS("pt_bold_heading.ttf", pt_bold_heading);
      this.addFont("pt_bold_heading.ttf", "PT Bold Heading", "Bold");
      this.addFileToVFS("NotoSansArabic-Bold.ttf", noto);
      this.addFont("NotoSansArabic-Bold.ttf", "Noto Sans Arabic", "Bold");
      this.addFileToVFS("amiri_bold.ttf", amiri_bold);
      this.addFont("amiri_bold.ttf", "Amiri", "Bold");
      this.addFileToVFS("NotoNaskhArabic-Bold-bold.ttf", NotoNaskhArabic_Bold);
      this.addFont("NotoNaskhArabic-Bold-bold.ttf", "NotoNaskhArabic", "bold");
      this.addFileToVFS(
        "NotoNaskhArabic-Regular-normal.ttf",
        NotoNaskhArabic_Normal
      );
      this.addFont(
        "NotoNaskhArabic-Regular-normal.ttf",
        "NotoNaskhArabic",
        "normal"
      );
      this.addFileToVFS("Al-Jazeera-Arabic-Bold-bold.ttf", Al_Jazeera_Arabic);
      this.addFont(
        "Al-Jazeera-Arabic-Bold-bold.ttf",
        "Al Jazeera Arabic",
        "Bold"
      );
    };
    JsPDF.API.events.push(["addFonts", callAddFont]);
  },
  async mounted() {
    this.$store.commit("settings/SET_PRIMARY_COLOR", {
      color: this.settings.primaryColor,
    });
    this.$store.commit("settings/SET_THEME", { theme: this.settings.theme });

    // Try auto-login once on app initialization (refresh token is in HTTP-only cookie)
    // IMPORTANT: Wait for auto-login to complete before allowing other API calls
    if (this.settings.activeBuilding) {
      try {
        // Set initial refresh flag so axios interceptor can queue requests
        const autoLoginPromise = this.$store.dispatch("user/TryAutoLogin");
        setInitialRefresh(autoLoginPromise);
        await autoLoginPromise;
      } catch (error) {
        // Auto-login failed - user will be redirected to login page by LOGOUT action
        console.error("Auto-login failed:", error);
      }
    }
  },
  sockets: {
    connect: function () {},
    forceLogout: function (data) {

      // Clear user session
      this.$store.dispatch("user/LOGOUT");

      // Show notification to user
      const reasonMessages = {
        password_changed: this.$t("forceLogout.passwordChanged"),
        account_deactivated: this.$t("forceLogout.accountDeactivated"),
        mfa_enabled: this.$t("forceLogout.mfaEnabled"),
        security_event: this.$t("forceLogout.securityEvent"),
      };

      const title =
        reasonMessages[data.reason] || this.$t("forceLogout.sessionExpired");
      const description =
        data.message || this.$t("forceLogout.loggedOut");

      this.$notification.warning({
        message: title,
        description: description,
        duration: 0, // Don't auto-close
      });

      // Redirect to login page
      if (this.$route.path !== "/auth/login") {
        this.$router.push("/auth/login");
      }
    },
  },
  watch: {
    "$store.state.settings.theme"(theme) {
      this.$store.commit("settings/SET_THEME", { theme });
    },
    authorized(authorized) {
      if (authorized && this.currentRoute === "/auth/login") {
        this.$router.replace(this.nextRoute);
      }
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("settings/SETUP_URL_SETTINGS", query);
    },
  },
};
</script>
